import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  /** Where the back arrow goes. Defaults to browser back. */
  backTo?: string;
}

/** Standard header for a settings sub-page, with a back affordance. */
export default function PageHeader({ title, subtitle, icon: Icon, backTo }: PageHeaderProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <header className="flex items-start gap-4">
      <button
        type="button"
        onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
        aria-label={t('common.goBack')}
        className="mt-1 p-2.5 rounded-2xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-800 hover:text-neutral-900 dark:hover:text-neutral-50 transition-colors shrink-0"
      >
        <ArrowLeft className="w-5 h-5" />
      </button>
      <div className="flex items-start gap-3">
        {Icon && (
          <div className="w-11 h-11 rounded-2xl bg-neutral-900 dark:bg-neutral-100 text-white dark:text-neutral-900 flex items-center justify-center shrink-0">
            <Icon className="w-5 h-5" />
          </div>
        )}
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-neutral-900 dark:text-neutral-50">{title}</h1>
          {subtitle && <p className="text-neutral-500 dark:text-neutral-400 text-sm mt-0.5">{subtitle}</p>}
        </div>
      </div>
    </header>
  );
}
